<template>
    <el-form-item :label="config.label" :prop="config.name">
        <el-input v-model="config.value" v-if="config.type === 'input'" :style="config.style"></el-input>
        <RemoteSelect v-model="config.value" :url="config.url" :options="config.options" v-else-if="config.type === 'select'" :style="config.style"></RemoteSelect>
        <el-date-picker v-model="config.value" v-else-if="config.type === 'datetimerange'"
                        type="datetimerange" range-separator="~" :default-time="['00:00:00', '23:59:59']"
                        value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
        <el-date-picker v-model="config.value" v-else-if="config.type === 'daterange'"
                        type="daterange" range-separator="~"
                        value-format="yyyy-MM-dd" style="width: 260px"></el-date-picker>
        <Cascade v-model="config.value" v-else-if="config.type === 'cascade'"></Cascade>
    </el-form-item>
</template>

<script>
    import RemoteSelect from '@/components/RemoteSelect'
    import Cascade from '@/components/Cascade'

    export default {
        components: {
            RemoteSelect,
            Cascade,
        },
        props: ["config"]
    }
</script>